import { t } from "@/languages/i18n"
import { message } from "antd"
import { HttpClient } from "../app/api/HttpClient"
import { API_PREFIX_MEMBERS_PATH } from "../constants/prefix-path-api"
import { CustomerPayload, FilterSearchParams } from "../types/types"

export const fetchCustomers = async (searchTerms: { [key: string]: string } = {}) => {
  const params: FilterSearchParams = {
    populate: "*",
    sort: "createdAt:desc",
    filters: {},
    pagination: {
      pageSize: "100",
      withCount: true,
    },
  }
  const excludedKeys = [
    "current",
    "pageSize",
    "start",
    "limit",
    "total",
    "page",
    "sort",
    "fields",
    "populate",
    "locale",
  ]

  Object.keys(searchTerms).forEach(key => {
    const value = searchTerms[key]

    if (key === "sort") {
      params.sort = value
    } else if (key === "fields") {
      // @ts-ignore - fields được hỗ trợ bởi API
      params.fields = value
    } else if (key === "populate") {
      params.populate = value
    } else if (key === "locale") {
      params.locale = value
    } else if (!excludedKeys.includes(key)) {
      if (value) {
        params.filters[key] = { $containsi: value }
      }
    } else if (value) {
      params.pagination = {
        ...params.pagination,
        [key]: value,
      }
    }
  })

  try {
    const response = await HttpClient.get(`${API_PREFIX_MEMBERS_PATH}`, { params,skipDomainFilter:true })
    return {
      data: response.data,
      meta: response.meta,
    }
  } catch (error) {
    message.error(t("Failed to fetch customers. Please try again."))
    throw error
  }
}

export const fetchCustomerId = async (id: number) => {
  try {
    const response = await HttpClient.get(`${API_PREFIX_MEMBERS_PATH}/${id}?populate=*`,{skipDomainFilter:true})
    return response.data
  } catch (error) {
    message.error(t("Failed to fetch customer information. Please try again."))
    throw error
  }
}

export const deleteCustomer = async (id: number) => {
  try {
    return await HttpClient.delete(`${API_PREFIX_MEMBERS_PATH}/${id}`,{skipDomainFilter:true})
  } catch (error) {
    message.error(t("Failed to delete customer. Please try again."))
    throw error
  }
}

export const updateCustomer = async (id: number, data: CustomerPayload) => {
  try {
    return await HttpClient.put(`${API_PREFIX_MEMBERS_PATH}/${id}`, data,{skipDomainFilter:true})
  } catch (error) {
    message.error(t("Failed to update customer. Please try again."))
    throw error
  }
}

export const addCustomer = async (data: CustomerPayload) => {
  try {
    return await HttpClient.post(`${API_PREFIX_MEMBERS_PATH}`, data, {skipDomainFilter:true})
  } catch (error) {
    message.error(t("Failed to add customer. Please try again."))
    throw error
  }
}
